export const scenarioMixin = {
  computed: {
    scenarioId () {
      return this.$route.params.scenarioId
    },
    playlistId () {
      return this.$route.params.playlistId
    },
    scenarioData () {
      return this.$store.getters["scenarioModule/getScenario"](this.scenarioId);
    },
    playlistData () {
      return this.$store.getters["scenarioModule/getPlaylist"](this.playlistId);
    },
    playlistItemCount () {
      return ( this.playlistData ? this.playlistData.items.length : 0)
    }
  }
}